import { Map } from "immutable";
import Vue from "vue";
import { db } from "@/firebase/firebaseConfig.js";
import * as VesselUtil from "@/utils/VesselUtil";

export default {
  /**
   * 船舶の静的情報を更新
   *
   * @param context
   * @param vesselIds
   */
  updateVesselInfos: (context, vesselId) => {
    return new Promise((resolve, reject) => {
      db.collection("vessel_info")
        .doc(vesselId)
        .get()
        .then(function (doc) {
          if (doc.exists) {
            context.commit("updateVesselInfo", {
              id: vesselId,
              data: doc.data()
            });
            resolve();
          }
        })
        .catch(function (error) {
          Vue.$log.error("Error getting document:", error);
          reject();
        });
    });
  },
  setCurrentTime: (context, payload) => {
    const vessels = context.state.vessels.asImmutable();
    let movements = Map();

    vessels.map((vessel, vesselId) => {
      const movement = VesselUtil.getVesselMovement(vessel, payload);
      if (
        movement &&
        movement.location.latitude &&
        movement.location.longitude
      ) {
        movements = movements.set(vesselId, movement);
      }
    });

    context.commit("setVesselMovements", movements);
    context.commit("setCurrentTime", payload);
  },
  fetchEnterpriseVessel: (context, vessel) => {
    let updateData = context.state.enterpriseVesselMap.set(vessel.id);

    context.commit("SET_ENTERPRISE_VESSEL", updateData);
  },
  fetchSelectedVessel: (context, vessel) => {
    let updateData = context.state.selectedVesselMap.set(vessel.id);

    context.commit("SET_SELECTED_VESSEL", updateData);
  }
}
